import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from "@ngrx/store";
import { DialogService } from "primeng/dynamicdialog";

import { tap } from "rxjs";

import { ResponsiveHelperService } from "src/app/services/responsive-helper.service";

import { UploadFileComponent } from "src/app/shared/upload-file/upload-file.component";

import { selectJob } from "../job-tool.reducer";

import { JobDocumentsActions } from "./job-files.actions";

export const openUploadFileDialog = createEffect((
  actions$ = inject(Actions),
  dialogService = inject(DialogService),
  store = inject(Store),
  responsiveHelper = inject(ResponsiveHelperService)
) => {
    return actions$.pipe(
      ofType(JobDocumentsActions.uploadDocumentButtonClicked),
      concatLatestFrom(() => store.select(selectJob)),
      tap(([ _action, job ]) => {
        dialogService.open(UploadFileComponent, {
          header: 'Upload Document',
          data: {
            relatedObjects: [ job.id ],
            jobId: job.id,
          },
          width: responsiveHelper.dialogWidth,
          contentStyle: {
            'padding-bottom': 0,
          },
        });
      }),
    );
}, { functional: true, dispatch: false });
